export default __webpack_public_path__ + "alberta-ic-order.44a3d190404a3e1eefc2.svg";